function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_987",
  "data-name": "Group 987",
  transform: "translate(-9.5 -12.507)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  id: "Path_699",
  "data-name": "Path 699",
  d: "M14.983,20.79l3.334-3.334V34.309a1.455,1.455,0,1,0,2.909,0V17.456L24.56,20.79a1.455,1.455,0,0,0,2.06-2.057L20.8,12.915a1.5,1.5,0,0,0-.457-.305L20.33,12.6h0a1.452,1.452,0,0,0-.739-.076,1.314,1.314,0,0,0-.18.035,1.422,1.422,0,0,0-.663.355L12.926,18.73a1.455,1.455,0,0,0,2.057,2.06Z",
  transform: "translate(5.729)"
}), /*#__PURE__*/React.createElement("path", {
  fill: 0,
  id: "Path_700",
  "data-name": "Path 700",
  d: "M40.045,19.5a1.455,1.455,0,0,0-1.455,1.455v4.364H12.409V20.955a1.455,1.455,0,0,0-2.909,0v5.818a1.455,1.455,0,0,0,1.455,1.455H40.045A1.455,1.455,0,0,0,41.5,26.773V20.955A1.455,1.455,0,0,0,40.045,19.5Z",
  transform: "translate(0 13.351)"
}));

var SvgFileupload = function SvgFileupload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29.072,
    viewBox: "0 0 32 29.072",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileupload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fileupload.1cda8570.svg";
export { ForwardRef as ReactComponent };